'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mihoyoStore = require('mihoyo-store');

var _mihoyoStore2 = _interopRequireDefault(_mihoyoStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 直接量处理js自定义事件
var customEvent = {
  // 保存事件类型，处理函数数组映射
  handlers: new _mihoyoStore2.default('eventHandlers'),

  /**
   * 注册事件
   * @param type 事件名称
   * @param handler 事件处理函数
   * @param once 是否只执行一次
   */
  on: function on(type, handler) {
    var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // 判断事件处理数组是否有该类型事件
    if (customEvent.handlers[type] === undefined) {
      customEvent.handlers[type] = [];
    }
    // 将处理事件push到事件处理数组里面
    customEvent.handlers[type].push({
      once: once,
      handler: handler
    });
  },


  /**
   * 执行一次
   * @param type 事件名称
   * @param handler 事件处理函数
   */
  once: function once(type, handler) {
    customEvent.on(type, handler, true);
  },


  /**
   * 触发一个事件
   * @param type 事件名称
   * @param data 事件返回数据对象
   */
  emit: function emit(type, data) {
    // 判断是否存在该事件类型
    if (customEvent.handlers[type] instanceof Array) {
      var handlers = customEvent.handlers[type];
      // 处理once的情况
      var newHandlers = [];
      for (var i = 0; i < handlers.length; i++) {
        // 执行触发
        handlers[i].handler(data);

        if (!handlers[i].once) {
          newHandlers.push(handlers[i]);
        }
      }
      customEvent.handlers[type] = newHandlers;
    }
  },


  /**
   * 移除事件监听
   * @param type 事件名称
   * @param handler 事件处理函数
   */
  remove: function remove(type, handler) {
    if (customEvent.handlers[type] instanceof Array) {
      var tmpHandler = customEvent.handlers[type];
      // 在同一个事件类型下的可能存在多种处理事件，找出本次需要处理的事件
      for (var i = 0; i < tmpHandler.length; i++) {
        // 找出本次需要处理的事件下标
        if (tmpHandler[i].handler === handler) {
          // 删除处理事件
          tmpHandler.splice(i, 1);
          break;
        }
      }
    }
  },


  /**
   * 清空事件所有监听
   * @param type
   */
  clear: function clear(type) {
    if (customEvent.handlers[type] instanceof Array) {
      customEvent.handlers[type] = [];
    }
  }
}; /**
    * 自定义事件对象，可通过它实现任意对象间的通信
    * Created by spring on 2018/11/21.
    */

exports.default = customEvent;